import { z } from "zod";

export const UserFormSchema = z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email({
        message: "Please enter a valid email.",
    }),
    password: z.string().min(6),
})